import { ApiClient } from 'ApiClient';
import { FiscalOutlet, FiscalReading } from 'interfaces';

class FiscalService {
  public async getOutlets(): Promise<FiscalOutlet[]> {
    return ApiClient.get<FiscalOutlet[]>('fiscal/outlets');
  }

  /**
   * type 'x' reads and changes nothing. type 'z' closes the period and
   * cannot be undone, which is why it is never the default anywhere.
   */
  public async takeReading(
    outletId: number,
    type: 'x' | 'z',
    print: boolean,
  ): Promise<FiscalReading> {
    return ApiClient.post('fiscal/reading', {
      outlet_id: outletId,
      type,
      print: print ? 1 : 0,
    });
  }

  /**
   * Cash a manual order: allocate the fiscal receipt and print it on the
   * outlet's own till printer. Replaces the browser print dialog, which was
   * still producing the old pre-fiscal slip.
   */
  public async issueOrder(
    orderId: number,
    paymentType: string,
  ): Promise<{ receiptNo: string | null; total: string | null; text: string }> {
    return ApiClient.post('fiscal/issue-order', {
      orderId,
      paymentType,
    });
  }

  /** The guest's bill before paying. Writes nothing and leaves the table open. */
  public async preBill(
    tableOrderId: number,
    print: boolean,
  ): Promise<{ text: string; printJobId: number | null }> {
    return ApiClient.post('fiscal/pre-bill', {
      tableOrderId,
      print: print ? 1 : 0,
    });
  }
}

const singleton = new FiscalService();

export { singleton as FiscalService };
